"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wallet = exports.TextContent = exports.Root = exports.Arrow = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('button')(({
  onClick,
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.text.primary,
  cursor: 'pointer',
  display: 'flex',
  fontSize: '1.4rem',
  gap: theme.spacing(1),
  position: 'relative',
  padding: theme.spacing(2),
  border: 0,
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(1),
  maxWidth: '100%',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '330px'
  },
  ...(onClick ? {
    '&:hover': {
      backgroundColor: theme.palette.grey[200]
    },
    '&:focus': {
      color: theme.palette.text.primary,
      outline: `1px solid ${theme.palette.default.dark}`
    }
  } : null)
}));
const Wallet = exports.Wallet = (0, _mui.styled)(_icons.Wallet)({
  alignSelf: 'baseline'
});
const TextContent = exports.TextContent = (0, _mui.styled)(_mui.Typography)({
  flexGrow: 1,
  textAlign: 'left'
});
const Arrow = exports.Arrow = (0, _mui.styled)(_icons.ArrowRightThin)(({
  theme
}) => ({
  fontSize: '1.6rem'
}));
//# sourceMappingURL=styles.js.map